import { TenantsListEnum } from '@ui-core/enums/tenants-list.enum'
import { TenantRouteConfigInterface } from '@ui-core/interfaces/route-config.interface'

const TENANT_ROUTES_PERMISSIONS: Record<string, () => Promise<TenantRouteConfigInterface>> = {
    [TenantsListEnum.BIOCANVAS]: () =>
        import('@tenants/biocanvas/constants/routes-permissions.constant').then((m) => ({
            tenant: TenantsListEnum.BIOCANVAS,
            routes: m.ROUTE_CONFIG
        })),
    [TenantsListEnum.CUCUMBER]: () =>
        import('@tenants/cucumber/constants/routes-permissions.constant').then((m) => ({
            tenant: TenantsListEnum.CUCUMBER,
            routes: m.ROUTE_CONFIG
        })),
    [TenantsListEnum.COMVITA]: () =>
        import('@tenants/comvita/constants/routes-permissions.constant').then((m) => ({
            tenant: TenantsListEnum.COMVITA,
            routes: m.ROUTE_CONFIG
        }))
}

export { TENANT_ROUTES_PERMISSIONS }
